<template>
  <div class="base-form-div">
    <div>
      <el-form
        :label-position="labelPosition"
        ref="form"
        :model="{}"
        label-width="80px"
        size="mini"
      >
        <el-form-item label="名称">
          <el-input v-model="name"></el-input>
        </el-form-item>
        <el-form-item v-for="(item, index) in attrForm" :label="item.name">
          <el-color-picker
            @change="changeColor"
            :predefine="predefineColors"
            show-alpha
            :color-format="'hex'"
            v-model="item.color"
          >
          </el-color-picker>
        </el-form-item>
        <!-- <el-form-item label="显示层级">
          <el-input-number
            @change="formSetChange"
            v-model="formSet.zIndex"
            controls-position="right"
          ></el-input-number>
        </el-form-item> -->
      </el-form>
    </div>
    <div v-html="svgElement" id="drawing" class="svg-board"></div>
    <div class="form-bottom">
      <el-button class="base-button" size="mini" type="primary" @click="savePlot"
        >确定</el-button
      >
      <el-button class="base-button" size="mini" type="primary" @click="deletePlot"
        >取消</el-button
      >
    </div>
  </div>
</template>

<script>
//--常規
//--文本
//--衬线
//--辅件
//--信息
//--尾线
import axios from "axios";
import { SVG } from "@svgdotjs/svg.js";
import { svg2CanvasExt, svgToblobJB, svgToUrl } from "../MilitaryPlot/lib/image.js";
import { getCommonAjax } from "@/api/common.js";
import { createMark, deleteByMarkId } from "@/api/vectorPlot/index.js";
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js";
import * as Help from "@/components/PlanEditor/Actions/help.js";
let entity;
export default {
  props: ["subData"],
  data() {
    return {
      predefineColors: ["#ff0000", "#0000ff", "#00ff00", "#00ffff"],
      labelPosition: "left",
      attrForm: [],
      svgElement: "",
      timer: undefined,
      SVGObj: undefined,
      changeColorArr: ["path", "polygon"],
      name: "",
      formSet: {
        materialType: "ImageMaterialProperty",
        materialOption: {
          color: "rgba(255, 255, 255, 1)",
          image: "",
        },
        zIndex: 0,
      },
    };
  },
  async created() {
    this.name = this.subData.title;
    let url = NG_Server + "/gisData/svg/" + this.subData.icon;
    var res = await axios.get(url);
    this.svgElement = res.data;
  },
  mounted() {
    this.$nextTick(() => {
      let node = null;
      this.timer = setInterval(() => {
        node = document.getElementById("drawing"); //获取元素
        if (node && node.firstChild) {
          clearInterval(this.timer);
          this.initSVGObj(node);
          this.initAttrs();
        }
      }, 1);
    });
  },
  methods: {
    formSetChange() {
      StyleUtil.setStyle2Entity(this.formSet, entity, "rectangle");
    },
    initSVGObj(node) {
      if (this.SVGObj) {
        return this.SVGObj;
      }
      this.SVGObj = SVG(node);
      return this.SVGObj;
    },
    initAttrs() {
      //初始化属性
      this.attrForm = this.getSelfAttrForm();
    },

    getSelfAttrForm() {
      var pathArr = this.SVGObj.find("path");
      var attrForm = pathArr.map((path, index) => {
        var fillColor = path.attr("fill");
        return {
          color: fillColor,
          name: "部件" + Number(index + 1) + "颜色",
        };
      });

      if (pathArr.length === 1) {
        attrForm[0].name = "填充颜色";
      }
      return attrForm;
    },
    saveAttr() {
      //   let element = document.getElementById("drawing"); //获取元素
      //   let svgdom = element.firstChild;
      //   var url = svgToUrl(svgdom);
      //   entity.rectangle.material = url;
      //   entity.rectangle.attr = entity.rectangle.attr || {};
      //   var styleAttr = entity.rectangle.attr;
      //   styleAttr.attrForm = this.attrForm;
    },
    changeText() {
      var textArr = this.SVGObj.find("text");
      textArr.tspan(this.attrForm.text);
    },
    changeColor() {
      var pathArr = this.SVGObj.find("path");
      this.attrForm.forEach((item, index) => {
        pathArr[index].attr("fill", item.color);
        // pathArr[index].attr("fill", "none");
        // pathArr[index].attr("stroke-dasharray", "5,5");
      });
      this.saveAttr();
    },
    changeWidth() {
      var pathArr = this.SVGObj.find("path");
      pathArr.css("stroke-width", this.attrForm.width);
    },
    setStyle(style, att, value) {
      var atts = style.split(";");
      var orig = undefined;
      for (var i = 0; i < atts.length; i++) {
        var arrPro = atts[i].split(":");
        if (arrPro[0] == att) {
          orig = arrPro[1];
          break;
        }
      }
      var before = att + ":" + orig;
      var after = att + ":" + value;
      const regExp = new RegExp(`${before}`, "ig");
      const str = style.replace(regExp, after);
      return str;
    },
    savePlot() {
      let element = document.getElementById("drawing"); //获取元素
      let svgdom = element.firstChild;
      var url = svgToblobJB(svgdom);

      this.$bus.$emit("saveBillBoardData", {
        imageUrl: url,
      });
      this.$parent.close();
    },
    deletePlot() {
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.base-form-div {
  padding: 20px;
}

.svg-board {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  margin-top: 20px;
  padding: 20px 0;
  height: 160px;

  > svg {
    height: 100% !important;
  }
}

.form-bottom {
  text-align: center;
  // border-top: 1px solid rgba(153, 153, 153, 0.50);
  padding-top: 20px;
}
</style>
<style lang="scss">
.svg-board {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  margin-top: 20px;
  padding: 20px 0;
  height: 160px;

  > svg {
    height: 100% !important;
  }
}
</style>
